module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-08-1f4c52bf03c94dd95736c6c9d510032f.jpg";